import React from 'react'
import PropTypes from 'prop-types'

const styles = {
    svg: {
        height: 24,
        width: 24,
        viewBox: '0 0 24 24',
        color: '#fff',
        flexShrink: 0,
    },
}

const userSVG = ({ classes, color, marginRight }) => (
    <svg version="1.1" style={{...styles.svg, marginRight: ('number' === typeof marginRight) ? marginRight : false}}>
        <metadata id="userSVG"/>
        <g>
            <path
                d=" M 12 0 C 5.364 0 0 5.364 0 12 C 0 18.636 5.364 24 12 24 C 18.636 24 24 18.636 24 12 C 24 5.364 18.636 0 12 0 Z  M 12 21.6 C 6.708 21.6 2.4 17.292 2.4 12 C 2.4 6.708 6.708 2.4 12 2.4 C 17.292 2.4 21.6 6.708 21.6 12 C 21.6 17.292 17.292 21.6 12 21.6 Z "
                fill={color}/>
            <path
                d=" M 12 6.9 C 13.16 6.9 14.1 7.84 14.1 9 C 14.1 10.16 13.16 11.1 12 11.1 C 10.84 11.1 9.9 10.16 9.9 9 C 9.9 7.84 10.84 6.9 12 6.9 Z  M 12 15.9 C 14.97 15.9 18.1 17.36 18.1 18 L 18.2 20 L 15 22 L 9.9 22 L 5.9 20 L 5.9 18 C 5.9 17.36 9.03 15.9 12 15.9 Z  M 12 5 C 9.79 5 8 6.79 8 9 C 8 11.21 9.79 13 12 13 C 14.21 13 16 11.21 16 9 C 16 6.79 14.21 5 12 5 Z  M 12 14 C 9.33 14 4 15.34 4 18 L 4 20 L 10.056 23 L 15.235 23 L 20 20 L 20 18 C 20 15.34 14.67 14 12 14 Z "
                fill={color}/>
        </g>
    </svg>
)

userSVG.defaultProps = {
    color: '#fff',
    //marginRight: 16,
}

userSVG.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    color: PropTypes.string,
    marginRight: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.number,
    ]),
}

export default userSVG
